/**
 * 仪表盘模块
 * 
 * 工作台首页，展示系统概览
 */

import type { WorkbenchModule } from '../types'

export const dashboardModule: WorkbenchModule = {
  meta: {
    name: 'dashboard',
    title: '仪表盘',
    description: '工作台系统概览',
    version: '0.1.0'
  },
  routes: [
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('./views/DashboardView.vue'),
      meta: { title: '仪表盘' }
    }
  ],
  menuItem: {
    id: 'dashboard',
    label: '工作台首页',
    path: '/dashboard',
    icon: 'dashboard',
    order: 10
  }
}
